import { signOut } from 'firebase/auth';

import { AuthBrandHeader } from '@/components/auth/auth-brand-header';
import { Button } from '@/components/shadcn/button';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/card';
import { auth } from '@/integrations/firebase/auth';
import { INVITE_CONTACT_EMAIL } from '@/lib/access';

/** Shown instead of the app when the founders rejected the account's PWZ
 * (`pwz_status: rejected`). The backend has already disabled the Auth account
 * and revoked its tokens; this covers the window until the current ID token
 * expires, so the doctor sees why rather than a broken app. */
export function AccountRejectedNotice() {
  return (
    <section className="flex flex-col items-center px-4 pt-8 sm:pt-16">
      <div className="mx-auto w-full max-w-md">
        <AuthBrandHeader tagline="Bezpieczeństwo leków przed ciążą, w ciąży i podczas karmienia piersią" />

        <Card className="border border-border bg-card shadow-sm">
          <CardHeader className="space-y-1 pb-4">
            <CardTitle className="text-center font-serif text-2xl font-semibold tracking-tight">
              Dostęp wstrzymany
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-5">
            <p className="text-sm leading-relaxed text-muted-foreground">
              Nie udało nam się potwierdzić numeru PWZ podanego przy
              rejestracji, dlatego dostęp do Chariot został wyłączony.
            </p>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Jeśli to pomyłka, napisz do nas:{' '}
              <a
                href={`mailto:${INVITE_CONTACT_EMAIL}`}
                className="font-medium text-brand hover:underline"
              >
                {INVITE_CONTACT_EMAIL}
              </a>
              .
            </p>
            <Button
              type="button"
              variant="outline"
              className="h-11 w-full font-medium"
              onClick={() => void signOut(auth)}
            >               Wyloguj się
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
